import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Input from '../elements/Input';
import Button from '../elements/Button';
import { Link } from 'react-router-dom';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const B2BRfqForm = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  quoteCart,
  onRemoveFromQuote,
  onUpdateQuantity,
  onSubmitRfq,
  ...props
}) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    requirements: '',
    shippingAddress: {
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    },
    billingSameAsShipping: true,
    billingAddress: {
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    }
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const outerClasses = classNames(
    'section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (name.startsWith('shipping_')) {
      const field = name.replace('shipping_', '');
      setFormData({
        ...formData,
        shippingAddress: { ...formData.shippingAddress, [field]: value }
      });
    } else if (name.startsWith('billing_')) {
      const field = name.replace('billing_', '');
      setFormData({
        ...formData,
        billingAddress: { ...formData.billingAddress, [field]: value }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const payload = {
        buyerInfo: {
          name: formData.name,
          company: formData.company,
          email: formData.email,
          requirements: formData.requirements,
          shippingAddress: formData.shippingAddress,
          billingSameAsShipping: formData.billingSameAsShipping,
          billingAddress: formData.billingAddress
        },
        products: quoteCart
      };
      
      const response = await fetch('/api/hubspot-quote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      
      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Failed to submit quote request');
      }

      onSubmitRfq(payload);
      setIsSubmitting(false);
      setSubmitSuccess(true);
      
      // Reset form
      setFormData({ 
        name: '', company: '', email: '', requirements: '',
        shippingAddress: { street: '', city: '', state: '', zip: '', country: '' },
        billingSameAsShipping: true,
        billingAddress: { street: '', city: '', state: '', zip: '', country: '' }
      });
    } catch (error) {
      console.error('Submission failed:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses} style={{ maxWidth: '75%', margin: '0 auto' }}>
          
          <div className="mb-32">
            <h3 className="mt-0 mb-16 text-center" style={{ color: '#A88756' }}>Your Quote Request</h3>
            <p className="text-sm text-color-high text-center mb-32" style={{ maxWidth: '600px', margin: '0 auto 32px', color: '#CBD5E1' }}>
              <strong>Looking for something else?</strong> If you need an item that is not listed on our product page, please <Link to="/contact" style={{ color: '#A88756', fontWeight: 'bold', textDecoration: 'underline' }}>Contact Us</Link> directly with your request.
            </p>
            
            {quoteCart.length === 0 ? (
              <div className="text-center p-32" style={{ borderRadius: '8px', border: '1px solid #1E293B', backgroundColor: '#141C2E' }}>
                <p className="m-0 text-sm" style={{ color: '#CBD5E1' }}>Your quote cart is empty. Please select products above to request a quote.</p>
              </div>
            ) : (
              <div className="p-24" style={{ borderRadius: '8px', border: '1px solid #1E293B', backgroundColor: '#141C2E' }}>
                <h6 className="mt-0 mb-16" style={{ color: '#A88756', fontSize: '1rem' }}>Selected Products ({quoteCart.length})</h6>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {quoteCart.map(item => (
                    <li key={item.cartId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #1E293B', paddingBottom: '12px', marginBottom: '12px' }}>
                      <div style={{ flexGrow: 1, paddingRight: '16px' }}>
                        <strong style={{ color: '#FFFFFF' }}>{item.name}</strong>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div style={{ width: '80px' }}>
                          <Input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => onUpdateQuantity(item.cartId, e.target.value)}
                            min="1"
                            style={{ padding: '4px 8px', height: '32px', color: '#FFFFFF', backgroundColor: '#0A0F1D', borderColor: '#1E293B' }}
                          />
                        </div>
                        <Button size="sm" onClick={() => onRemoveFromQuote(item.cartId)} style={{ padding: '4px 8px', fontSize: '12px' }}>Remove</Button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {!submitSuccess ? (
            <form onSubmit={handleSubmit}>
              <h5 className="mt-0 mb-16 pb-8" style={{ borderBottom: '1px solid rgba(168, 135, 86, 0.25)', color: '#A88756' }}>Contact Information</h5>
              <div className="mb-24">
                <Input id="name" name="name" type="text" label="Full Name" placeholder="Your full name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="mb-24">
                <Input id="company" name="company" type="text" label="Company Name" placeholder="Your company name" value={formData.company} onChange={handleChange} required />
              </div>
              <div className="mb-24">
                <Input id="email" name="email" type="email" label="Business Email" placeholder="you@company.com" value={formData.email} onChange={handleChange} required />
              </div>
              
              <h5 className="mt-32 mb-16 pb-8" style={{ borderBottom: '1px solid rgba(168, 135, 86, 0.25)', color: '#A88756' }}>Shipping Information</h5>
              <div className="mb-24">
                <Input id="shipping_street" name="shipping_street" type="text" label="Street Address" value={formData.shippingAddress.street} onChange={handleChange} required />
              </div>
              <div style={{ display: 'flex', gap: '16px' }} className="mb-24">
                <div style={{ flex: 1 }}><Input id="shipping_city" name="shipping_city" type="text" label="City" value={formData.shippingAddress.city} onChange={handleChange} required /></div>
                <div style={{ flex: 1 }}><Input id="shipping_state" name="shipping_state" type="text" label="State/Province" value={formData.shippingAddress.state} onChange={handleChange} required /></div>
              </div>
              <div style={{ display: 'flex', gap: '16px' }} className="mb-24">
                <div style={{ flex: 1 }}><Input id="shipping_zip" name="shipping_zip" type="text" label="Zip/Postal Code" value={formData.shippingAddress.zip} onChange={handleChange} required /></div>
                <div style={{ flex: 1 }}><Input id="shipping_country" name="shipping_country" type="text" label="Country" value={formData.shippingAddress.country} onChange={handleChange} required /></div>
              </div>

              <h5 className="mt-32 mb-16 pb-8" style={{ borderBottom: '1px solid rgba(168, 135, 86, 0.25)', color: '#A88756' }}>Billing Information</h5>
              <div className="mb-24">
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#CBD5E1' }}>
                  <input type="checkbox" name="billingSameAsShipping" checked={formData.billingSameAsShipping} onChange={handleChange} style={{ marginRight: '8px' }} />
                  Billing Address is same as Shipping
                </label>
              </div>

              {!formData.billingSameAsShipping && (
                <>
                  <div className="mb-24">
                    <Input id="billing_street" name="billing_street" type="text" label="Street Address" value={formData.billingAddress.street} onChange={handleChange} required={!formData.billingSameAsShipping} />
                  </div>
                  <div style={{ display: 'flex', gap: '16px' }} className="mb-24">
                    <div style={{ flex: 1 }}><Input id="billing_city" name="billing_city" type="text" label="City" value={formData.billingAddress.city} onChange={handleChange} required={!formData.billingSameAsShipping} /></div>
                    <div style={{ flex: 1 }}><Input id="billing_state" name="billing_state" type="text" label="State/Province" value={formData.billingAddress.state} onChange={handleChange} required={!formData.billingSameAsShipping} /></div>
                  </div>
                  <div style={{ display: 'flex', gap: '16px' }} className="mb-24">
                    <div style={{ flex: 1 }}><Input id="billing_zip" name="billing_zip" type="text" label="Zip/Postal Code" value={formData.billingAddress.zip} onChange={handleChange} required={!formData.billingSameAsShipping} /></div>
                    <div style={{ flex: 1 }}><Input id="billing_country" name="billing_country" type="text" label="Country" value={formData.billingAddress.country} onChange={handleChange} required={!formData.billingSameAsShipping} /></div>
                  </div>
                </>
              )}

              <h5 className="mt-32 mb-16 pb-8" style={{ borderBottom: '1px solid rgba(168, 135, 86, 0.25)', color: '#A88756' }}>Additional Details</h5>
              <div className="mb-24">
                 <Input
                    id="requirements"
                    name="requirements"
                    type="textarea"
                    label="Additional Requirements (Optional)"
                    placeholder="Specify target timelines, custom configurations, or delivery instructions..."
                    value={formData.requirements}
                    onChange={handleChange}
                    rows={4}
                  />
              </div>
              
              <div className="mt-32 text-center">
                <Button 
                  color="primary" 
                  wideMobile 
                  disabled={quoteCart.length === 0 || isSubmitting}
                  loading={isSubmitting}
                  type="submit"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Request for Quote'}
                </Button>
                {quoteCart.length === 0 && (
                  <p className="text-xs text-color-primary mt-8">Please add products to enable submission.</p>
                )}
              </div>
            </form>
          ) : (
            <div className="text-center p-32" style={{ borderRadius: '8px', border: '1px solid #A88756', backgroundColor: '#141C2E' }}>
              <h4 className="mt-0 mb-16 text-color-primary">Request Submitted!</h4>
              <p className="m-0" style={{ color: '#CBD5E1' }}>Thank you for your interest. Our SEES INTERNATIONAL team is preparing a customized quote for you and will be in touch shortly.</p>
              <div className="mt-24">
                <Button onClick={() => setSubmitSuccess(false)}>Submit Another Request</Button>
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
}

B2BRfqForm.propTypes = propTypes;
B2BRfqForm.defaultProps = defaultProps;

export default B2BRfqForm;

